const DESIGNS_BY_INDUSTRY = [
    {
        title: 'animal_and_pet',
        link: '/logo-maker/ideas/industry/animals-and-pets',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139888/animal.png',
    },
    {
        title: 'architecture',
        link: '/logo-maker/ideas/industry/architecture',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139899/architecture.png',
    },
    {
        title: 'art',
        link: '/logo-maker/ideas/industry/arts',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139897/art.png',
    },
    {
        title: 'automotive',
        link: '/logo-maker/ideas/tag/transportation',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139899/automotive.png',
    },
    {
        title: 'bands',
        link: '/logo-maker/ideas/industry/bands',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139890/bands.png',
    },
    {
        title: 'bar',
        link: '/logo-maker/ideas/industry/bars',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139890/bar.png',
    },
    {
        title: 'beauty',
        link: '/logo-maker/ideas/industry/beauty-and-cosmetics',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139901/beauty.png',
    },
    {
        title: 'catering',
        link: '/logo-maker/ideas/industry/catering-and-buffet-services',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139902/catering.png',
    },
    {
        title: 'childcare',
        link: '/logo-maker/ideas/industry/childcare-services',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139900/childcare.png',
    },
    {
        title: 'cleaning',
        link: '/logo-maker/ideas/industry/cleaning-services',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139891/cleaning.png',
    },
    {
        title: 'clothing',
        link: '/logo-maker/ideas/tag/clothing',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139892/clothing.png',
    },
    {
        title: 'coffee_shop',
        link: '/logo-maker/ideas/tag/coffee-shop',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139890/cofeeshop.png',
    },
    {
        title: 'construction',
        link: '/logo-maker/ideas/industry/construction',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139885/contruction.png',
    },
    {
        title: 'dancing',
        link: '/logo-maker/ideas/industry/dancing',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139881/dancing.png',
    },
    {
        title: 'dental',
        link: '/logo-maker/ideas/tag/dentist',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139882/dental.png',
    },
    {
        title: 'dj',
        link: '/logo-maker/ideas/industry/dj',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139900/dj.png',
    },
    {
        title: 'education',
        link: '/logo-maker/ideas/industry/education',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139889/education.png',
    },
    {
        title: 'electrical',
        link: '/logo-maker/ideas/industry/electrical-engineering',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139896/electrical.png',
    },
    {
        title: 'esports',
        link: '/logo-maker/ideas/industry/esports-fan-club',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139892/esports.png',
    },
    {
        title: 'event_planner',
        link: '/logo-maker/ideas/industry/events-planning',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139902/eventplanner.png',
    },
    {
        title: 'fashion',
        link: '/logo-maker/ideas/industry/fashion-and-apparel',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139893/fashion.png',
    },
    {
        title: 'finance',
        link: '/logo-maker/ideas/tag/finance',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139900/finance.png',
    },
    {
        title: 'fitness',
        link: '/logo-maker/ideas/tag/fitness',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139905/fitness.png',
    },
    {
        title: 'floral',
        link: '/logo-maker/ideas/tag/flower',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139899/floral.png',
    },
    {
        title: 'food',
        link: '/logo-maker/ideas/tag/food',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139895/food.png',
    },
    {
        title: 'gaming',
        link: '/logo-maker/ideas/industry/gaming',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139882/gaming.png',
    },
    {
        title: 'gym',
        link: '/logo-maker/ideas/tag/fitness',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139889/gym.png',
    },
    {
        title: 'icecream',
        link: '/logo-maker/ideas/industry/ice-cream',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139886/icecream.png',
    },
    {
        title: 'jewelry',
        link: '/logo-maker/ideas/industry/jewelry',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139892/jewelry.png',
    },
    {
        title: 'landscaping',
        link: '/logo-maker/ideas/industry/gardening-services',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139906/landscaping.png',
    },
    {
        title: 'law_firm',
        link: '/logo-maker/ideas/industry/law',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139885/lawfirm.png',
    },
    {
        title: 'makeup',
        link: '/logo-maker/ideas/industry/makeup',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139892/makeup.png',
    },
    {
        title: 'medical',
        link: '/logo-maker/ideas/tag/medical',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139909/medical.png',
    },
    {
        title: 'music',
        link: '/logo-maker/ideas/industry/music',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139903/music.png',
    },
    {
        title: 'non_profit',
        link: '/logo-maker/ideas/industry/non-profit',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139894/nonprofit.png',
    },
    {
        title: 'paint',
        link: '/logo-maker/ideas/industry/painting',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139907/paint.png',
    },
    {
        title: 'pharmacy',
        link: '/logo-maker/ideas/industry/pharmaceutical',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139893/pharmacy.png',
    },
    {
        title: 'photography',
        link: '/logo-maker/ideas/industry/photography',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139910/photography.png',
    },
    {
        title: 'pizza',
        link: '/logo-maker/ideas/tag/pizza',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139891/pizza.png',
    },
    {
        title: 'real_estate',
        link: '/logo-maker/ideas/industry/real-estate',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139893/realestate.png',
    },
    {
        title: 'restaurant',
        link: '/logo-maker/ideas/industry/restaurants',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139906/restaurant.png',
    },
    {
        title: 'salon',
        link: '/logo-maker/ideas/industry/beauty-salon',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139904/salon.png',
    },
    {
        title: 'skincare',
        link: '/logo-maker/ideas/industry/beauty-and-cosmetics',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139903/skincare.png',
    },
    {
        title: 'spa',
        link: '/logo-maker/ideas/industry/spa',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139905/spa.png',
    },
    {
        title: 'sports',
        link: '/logo-maker/ideas/tag/sports',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139897/sports.png',
    },
    {
        title: 'technology',
        link: '/logo-maker/ideas/industry/technology',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139889/technology.png',
    },
    {
        title: 'travel',
        link: '/logo-maker/ideas/industry/travel-or-tourism',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139888/travel.png',
    },
    {
        title: 'woodworking',
        link: '/logo-maker/ideas/tag/wood',
        imgUrl: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/aed33635b60152e24a8e43e61f968028-1618911139897/woodworking.png',
    },
];

const POPULAR_KEYWORDS = [
    {
        tagName: 'Fortnite Logos',
        tagId: 'fortnite',
        tagType: 'tag',
    },
    {
        tagName: 'Clan Logos',
        tagId: 'clan',
        tagType: 'tag',
    },
    {
        tagName: 'Twitch Logos',
        tagId: 'twitch',
        tagType: 'tag',
    },
    {
        tagName: 'Circle Logos',
        tagId: 'circle',
        tagType: 'tag',
    },
    {
        tagName: 'Church Logos',
        tagId: 'church',
        tagType: 'tag',
    },
    {
        tagName: 'Podcast Logos',
        tagId: 'podcast',
        tagType: 'tag',
    },
    {
        tagName: 'Clothing Logos',
        tagId: 'clothing',
        tagType: 'tag',
    },
    {
        tagName: 'Hair Logos',
        tagId: 'hair',
        tagType: 'tag',
    },
    {
        tagName: 'Bakery Logos',
        tagId: 'bakery',
        tagType: 'tag',
    },
    {
        tagName: 'Barber Logos',
        tagId: 'barber-shops',
        tagType: 'industry',
    },
    {
        tagName: 'Pubg Logos',
        tagId: 'pubg',
        tagType: 'tag',
    },
    {
        tagName: 'Handyman Logos',
        tagId: 'handyman',
        tagType: 'tag',
    },
    {
        tagName: 'Landscape',
        tagId: 'landscape',
        tagType: 'tag',
    },
    {
        tagName: 'Law Firm Logos',
        tagId: 'law',
        tagType: 'industry',
    },
];

const HERO_IMG_URL = '4e3ee57c23086da18306c7ff9b92cdce-1618488764038/discover-logo-ideas-hero.png';

const IDEAS_HUB_ACTIONS = {
    START_BRIEF: 'Start brief',
    TAG_CLICKED: 'Tag clicked',
};

const IDEAS_HUB_SECTIONS = {
    HEADER_CTA: 'Header CTA',
    INDUSTRIES: 'Industries',
    STYLES: 'Styles',
    MAKE_YOUR_LOGO: 'Make your logo',
    POPULAR_KEYWORDS: 'Popular Keywords',
    FOOTER: 'Footer',
};

export { HERO_IMG_URL, POPULAR_KEYWORDS, DESIGNS_BY_INDUSTRY, IDEAS_HUB_ACTIONS, IDEAS_HUB_SECTIONS };
